import React from "react";
import { useI18n } from "../i18n";
import Reveal from "../components/Reveal";
import { Check } from "lucide-react";

const INFRA_IMG = "https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg";

const Eyebrow = ({ children }) => (
  <div className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-[#00B3B3]/90 uppercase">
    <span className="h-px w-8 bg-[#00B3B3]/60" />
    {children}
  </div>
);

const VALUES_PT = [
  { t: "Rigor", d: "Engenharia de dados como disciplina. Auditabilidade e testes automatizados em primeiro lugar." },
  { t: "Pragmatismo", d: "Entregamos o suficiente para gerar valor — e iteramos. Sem astronáutica corporativa." },
  { t: "Transferência", d: "Time do cliente sobe junto. Documentação viva e enablement contínuo." },
  { t: "Foco em ROI", d: "Cada KPI escolhido precisa ter dono e impacto financeiro mensurável." },
];

const VALUES_EN = [
  { t: "Rigor", d: "Data engineering as a discipline. Auditability and automated tests first." },
  { t: "Pragmatism", d: "Ship enough to create value — then iterate. No corporate astronautics." },
  { t: "Transfer", d: "Client team grows with us. Living documentation and continuous enablement." },
  { t: "ROI focus", d: "Every chosen KPI must have an owner and measurable financial impact." },
];

export default function About() {
  const { t, lang } = useI18n();
  const values = lang === "pt" ? VALUES_PT : VALUES_EN;
  return (
    <div data-testid="page-about" className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <Reveal><Eyebrow>{t.about.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-6 font-heading font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              {t.about.title}
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-white/70 leading-relaxed">{t.about.body}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <ul className="mt-8 space-y-3">
              {t.about.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-white/80">
                  <Check size={18} className="text-[#00B3B3] mt-0.5 flex-shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.2}>
            <div className="relative h-72 lg:h-96 rounded-sm overflow-hidden border border-white/10">
              <img src={INFRA_IMG} alt="infra" className="absolute inset-0 w-full h-full object-cover opacity-70" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 font-mono text-[10px] tracking-widest text-white/70 border-t border-white/20 pt-3">
                {lang === "pt" ? "ENGENHARIA · GOVERNANÇA · ESCALA" : "ENGINEERING · GOVERNANCE · SCALE"}
              </div>
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {values.map((v, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <div className="bg-[#0a0a0a] p-8 h-full hover:bg-[#111] transition-colors">
              <div className="font-mono text-xs tracking-widest text-[#00B3B3]">0{i + 1}</div>
              <h3 className="mt-4 font-heading font-bold text-white text-xl">{v.t}</h3>
              <p className="mt-2 text-white/60 text-sm leading-relaxed">{v.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
